import { EmptyResponseSchema } from '../../../api/schemas';
import { adminApiPost } from '../client';
import { AdminLoginResponseSchema, type AdminLoginResponse } from '../schemas';

export function login(username: string, password: string): Promise<AdminLoginResponse> {
  return adminApiPost('/v1/admin/auth/login', AdminLoginResponseSchema, { username, password });
}

export function changePassword(
  currentPassword: string,
  newPassword: string,
  idempotencyKey: string,
): Promise<undefined> {
  return adminApiPost(
    '/v1/admin/auth/password',
    EmptyResponseSchema,
    { currentPassword, newPassword },
    idempotencyKey,
  );
}

export function logout(): Promise<undefined> {
  return adminApiPost('/v1/admin/auth/logout', EmptyResponseSchema);
}
